import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ResponsiveValue<T> =
    | T
    | Partial<Record<'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'default', T>>;

export const HelpTypes = {
    INFORMATION: 'INFORMATION',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
} as const;

export const HelpOptions = {
    EXPLORE: 'EXPLORE',
    SAVE_SPOTS: 'SAVE_SPOTS',
    GROW_NETWORK: 'GROW_NETWORK',
} as const;

export type HelpType = keyof typeof HelpTypes;
export type HelpOption = keyof typeof HelpOptions;

interface HelpState {
    helpOption?: HelpOption;
    currentMessageIndex: number;
    showHelp: boolean;
}

const initialState: HelpState = {
    helpOption: undefined,
    currentMessageIndex: 0,
    showHelp: false,
};

const helpSlice = createSlice({
    name: 'help',
    initialState,
    reducers: {
        hideHelp(state) {
            state.helpOption = undefined;
            state.currentMessageIndex = 0;
            state.showHelp = false;
        },
        setActiveTutorial(state, action: PayloadAction<HelpOption>) {
            state.helpOption = action.payload;
            state.currentMessageIndex = 0;
            state.showHelp = true;
        },
        setCurrentMessageIndex(state, action: PayloadAction<number>) {
            if (action.payload >= 0) {
                state.currentMessageIndex = action.payload;
            }
        },
    },
});

export const {
    hideHelp,
    setActiveTutorial,
    setCurrentMessageIndex,
} = helpSlice.actions;

export default helpSlice.reducer;
